import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ProductCard from '@/components/feature/ProductCard';
import { categories, products } from '@/mocks/products';

export default function Categories() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || categories[0].id;
  const [filteredProducts, setFilteredProducts] = useState(products);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeTab]);

  useEffect(() => {
    setFilteredProducts(products.filter((p) => p.category === activeTab));
  }, [activeTab]);

  const activeCategory = categories.find((c) => c.id === activeTab);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '商品分类' }]} />

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
                黄油商品分类
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                按品类浏览精选黄油产品，找到最适合您的那一款
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-2 mb-10">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setSearchParams({ tab: cat.id })}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeTab === cat.id
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            {activeCategory && (
              <div className="mb-8 p-5 md:p-6 bg-background-100 rounded-lg flex flex-col md:flex-row items-start gap-4">
                <div className="w-full md:w-48 h-32 md:h-36 rounded-md overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={activeCategory.image}
                    alt={activeCategory.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                    {activeCategory.name}
                  </h2>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {activeCategory.description}
                  </p>
                </div>
              </div>
            )}

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
              {filteredProducts.map((product) => (
                <ProductCard key={product.id} {...product} />
              ))}
            </div>

            {filteredProducts.length === 0 && (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <span className="w-8 h-8 flex items-center justify-center text-foreground-400">
                    <i className="ri-inbox-line text-2xl"></i>
                  </span>
                </div>
                <p className="text-foreground-500">暂无相关产品</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '在线黄油 - 商品分类',
            description: '按品类浏览精选黄油产品，发酵黄油、无盐黄油、动物黄油、进口黄油、有机黄油等多种类型。',
            url: 'https://dairio.github.io/categories',
            isPartOf: {
              '@type': 'WebSite',
              name: '在线黄油',
              url: 'https://dairio.github.io',
            },
          }),
        }}
      />
    </>
  );
}